
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const BioinformaticsPage = lazy(() => import('../pages/bioinformatics/page'));
const ForDoctorsPage = lazy(() => import('../pages/for-doctors/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorksPage />,
  },
  {
    path: '/bioinformatics',
    element: <BioinformaticsPage />,
  },
  {
    path: '/for-doctors',
    element: <ForDoctorsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
